/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import "moment-timezone";
import moment from "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import Verified from "../../assets/image/VV.svg";
import ReusableTable from "../UserInformation/ReusableTable";
import StatusButton from "./StatusButton";
import CommonewModel from "../commonModel/commonModel";

const RefundManagement = () => {
  const { search, refundList, refundListApi, userList } = useSelector(
    (state) => state.adminReducers
  );
  const [currentPage, setCurrentPage] = useState(1);
  const { websocket } = useContext(WebSocketContext);
  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {},
  });

  const refundStatus = (id) => {
    const refund = refundListApi?.list?.filter(
      (refund) => refund?.transaction_id === id
    )[0];
    return {
      status: refund?.status,
    };
  };

  useEffect(() => {
    let param = {
      transmit: "single",
      url: "refund_req_list",
      request: {
        date: "",
        limit: "20",
        page_no: search ? 1 : currentPage,
        search: search ? search : "",
      },
    };
    wsSend_request(websocket, param);
  }, [websocket, currentPage, search]);

  useEffect(() => {
    let param = {
      transmit: "single",
      url: "refund_list",
      request: {
        limit: "5000",
        page_no: currentPage,
      },
    };
    wsSend_request(websocket, param);
  }, [websocket, currentPage]);

  const currentFunction = (page) => {
    setCurrentPage(page);
  };
  const UserDetail = (id) => {
    const userInf = userList?.list?.filter((user) => user?.id === id)[0];
    return {
      userName: userInf?.username,
      useEmail: userInf?.email,
      mobileNUmber: userInf?.phone,
      user_code: userInf?.user_code,
    };
  };
  useEffect(() => {
    let param = {
      transmit: "single",
      url: "user_list",
      request: {
        status: true,
        limit: "10000000",
        page_no: 1,
        search: "",
        order_by: "-updated_at",
      },
    };
    wsSend_request(websocket, param);
  }, []);

  const headers = [
    { name: "Date & Time", key: "dateTime" },
    { name: "User Id", key: "userId" },
    { name: "Transaction Id", key: "transactionId" },
    { name: "Full Name", key: "full_name" },
    { name: "Mobile Number", key: "mobile_number" },
    { name: "Transaction Amount", key: "transactionAmount" },
    { name: "Note", key: "note" },
    { name: "Action", key: "action" },
  ];

  const openModal = (id, status) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title: "Create New Box",
      subtitle: "Create New Model",
      modalType: status,
      Data: id,
    });
  };
  const renderRow = (refund, index, visibleColumns) => {
    const status = refundStatus(refund?.transaction_id)?.status;

    return (
      <React.Fragment key={refund?.id}>
        <tr key={refund.id} className="user-management-table-detail">
          {visibleColumns?.includes("dateTime") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {moment(refund.created_at).format("YYYY-MM-DD HH:mm:ss")}
            </td>
          )}
          {visibleColumns?.includes("userId") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {refund.user_code ? refund.user_code : "-"}
            </td>
          )}
          {visibleColumns?.includes("transactionId") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {refund.transaction_id || "-"}
            </td>
          )}
          {visibleColumns?.includes("full_name") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {refund?.full_name ? refund?.full_name : "-"}
            </td>
          )}
          {visibleColumns?.includes("mobile_number") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {refund?.mobile_number ? refund?.mobile_number : "-"}
            </td>
          )}
          {visibleColumns?.includes("transactionAmount") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {refund.total_amount || "-"}
            </td>
          )}
          {visibleColumns?.includes("note") && (
            <td style={{ cursor: "default" }} className="Vertical_align">
              {refund.notes}
            </td>
          )}
          <td>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                <img
                  src={Verified}
                  alt="Verified"
                  style={{ height: "12px", width: "12px" }}
                />{" "}
                <span style={{ color: "#1AA773" }}>Notified </span>
              </div>
              {status === "Processing" ? (
                <>
                  <StatusButton
                    label="Reject"
                    type="reject"
                    onClick={() => openModal(refund?.transaction_id, "Reject")}
                  />
                  <StatusButton
                    label="Accept"
                    type="accept"
                    onClick={() => openModal(refund?.transaction_id, "Accept")}
                  />
                </>
              ) : status === "Reject" ? (
                <StatusButton label="Rejected" type="rejected" />
              ) : (
                <StatusButton label="Accepted" type="accepted" />
              )}
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  };

  return (
    <>
      <div style={{ margin: "2px" }} className="fixTableHead">
        <ReusableTable
          headers={headers}
          data={refundList?.list || []}
          paginationObject={refundList?.pagination}
          renderRow={renderRow}
          filters={{
            fromDate: false,
            toDate: false,
            period: false,
            search: true,
            searchPlaceholder: "Search by Transaction Id",
            userSelect: false,
            userOptions: [],
            export: false,
            isAdd: false,
            isAddtitle: "",
            isAddLink: "",
            reset: false,
          }}
          currentPage={currentPage}
          handlePageChange={currentFunction}
        />
      </div>
      {showModalNew?.open && (
        <CommonewModel
          setShowModalNew={setShowModalNew}
          showModalNew={showModalNew}
        />
      )}
    </>
  );
};

export default RefundManagement;
